import { useAuth } from '../context/AuthContext';

// Enveloppe une page SCADA : pour les comptes de niveau (Débutant/Intermédiaire/Avancé),
// désactive tous les contrôles (boutons, cases, interrupteurs) sans ajouter
// de bandeau visuel au-dessus du synoptique.
export default function ReadOnlyGate({ children }) {
  const { isNiveau } = useAuth();

  if (!isNiveau) return children;

  return (
    <div className="readonly-gate">
      <div className="readonly-locked">{children}</div>
    </div>
  );
}
